import React from 'react'
import styled from '@emotion/styled'
import {css} from '@emotion/core'

const GoodImageRoot = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  
  ${({maxSize, autoScale}) => autoScale 
    ? css`
      min-height: 170px;
    ` : css`
      width: ${maxSize}px;
      height: ${maxSize}px;
    `    
  }  
`

const Img = styled.img`
  display: block;
  ${({maxSize, autoScale}) => autoScale  
    ? css`
      max-width: 100%;
      max-height: 350px;
    ` : css`
      max-width: ${maxSize}px;
      max-height: ${maxSize}px;  
    `
  }
`

const GoodImage = ({
  good: {imageId, version},
  maxSize = 170,
  autoScale = false
}) => {
  return <GoodImageRoot maxSize={maxSize} autoScale={autoScale}>
    {imageId
      ? <Img
        src={`/app/img?goodImageId=${imageId}&version=${version}&size=${maxSize}`}
        maxSize={maxSize}
        autoScale={autoScale}/>
      : <div/>
    }
  </GoodImageRoot>
}

export default GoodImage
